import RequestPage from "./RequestPage";

const FiveYear = () => {
 return (
        <RequestPage title="Five Year Request"
            fetchUrl="/get-five-year-requests"
            editEndpoint="edit-five-year-request"
            deleteEndpoint="five-year-request"
            statusEndpoint="five-year-request" />
    );
}

export default FiveYear;